import { render, staticRenderFns } from "./AvailableReports.vue?vue&type=template&id=4ef65060"
import script from "./AvailableReports.vue?vue&type=script&lang=js"
export * from "./AvailableReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports